import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { TextArea } from "@jhool-io/fe-components";
import useToast from "../../../../../hooks/useToast";
import {
    CommunicationNoteChannel,
    INewCommunicationNote,
} from "../../../types/clients.types";
import { useAddCommunicationNote } from "../../../hooks/clients.mutations";

interface AddCommunicationNoteProps {
    channel: CommunicationNoteChannel;
    recordId: string;
    onFormSubmit(): void;
}

const schema = yup.object({
    body: yup
        .string()
        .trim()
        .required("Note is required")
        .max(1000, "Note cannot be longer than 1000 characters"),
});

export default function AddCommunicationNote({
    channel,
    recordId,
    onFormSubmit,
}: AddCommunicationNoteProps) {
    const params = useParams();
    const clientId = params.clientId as string;

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm<INewCommunicationNote>({
        resolver: yupResolver(schema),
    });

    const addCommunicationNote = useAddCommunicationNote(clientId);

    const { toast } = useToast();

    const onSubmit = (noteData: INewCommunicationNote) => {
        addCommunicationNote.mutate(
            { channel, record_id: recordId, body: noteData.body },
            {
                onSuccess: (res) => {
                    toast({
                        mode: "success",
                        message: res.message || "Note added successfully",
                    });
                    reset();
                    onFormSubmit();
                },
                onError: (err) => {
                    toast({
                        mode: "error",
                        message:
                            err.response?.data.message ||
                            "Could not add note at this time",
                    });
                },
            }
        );
    };

    return (
        <form id="add-communication-note" onSubmit={handleSubmit(onSubmit)}>
            <div className="fg">
                <TextArea
                    {...register("body")}
                    label="Add a note"
                    hasError={!!errors.body}
                    errorText={errors.body?.message}
                />
            </div>
        </form>
    );
}
